<template>
  <b-form>
    <b-row>
      <b-col
        v-for="bankField in bankDetailInputs"
        :key="bankField.dataField"
        cols="12"
        md="6"
        lg="4"
      >
        <b-form-group :label="bankField.label" :label-for="bankField.dataField">
          <b-input-group class="input-group-merge">
            <b-form-input
              :id="bankField.dataField"
              v-model="userData.bankDetails[bankField.dataField]"
              type="url"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col class="mt-2">
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="saveChanges"
        >
          Save Changes
        </b-button>
        <b-button
          variant="outline-secondary"
          type="reset"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          :to="{ name: 'apps-personels-list' }"
        >
          Close
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BInputGroup } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroup,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    saveChanges() {
      this.$emit('onSaveChanges')
    },
  },
  setup() {
    const userDataSocial = {
      twitter: 'https://www.twitter.com/adoptionism744',
      facebook: 'https://www.facebook.com/adoptionism664',
      instagram: 'https://www.instagram.com/adopt-ionism744',
      github: 'https://www.github.com/madop818',
      codepen: 'https://www.codepen.com/adoptism243',
      slack: '@adoptionism744',
    }

    // ? dataField is field name of `userDataSocial` object
    const bankDetailInputs = [
      {
        dataField: 'name',
        label: 'Name',
      },
      {
        dataField: 'IBAN',
        label: 'IBAN',
      },
      {
        dataField: 'BIC',
        label: 'BIC',
      },
      {
        dataField: 'bank',
        label: 'Bank',
      },
    ]

    return {
      userDataSocial,
      bankDetailInputs,
    }
  },
}
</script>

<style></style>
